"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="16282" id="valleyvibe" className="relative flex min-h-[90vh] w-full items-center justify-center overflow-hidden bg-black dark">
      {}
      <div className="absolute inset-0 z-10 bg-black/40" />

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <div className="mx-auto max-w-4xl space-y-8">
          {}
          <div className="flex justify-center">
            
          </div>

          {}
          <h1 className="font-sans text-5xl font-black leading-tight text-white md:text-7xl lg:text-8xl">
            <span className="block uppercase tracking-tighter text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.7)]">valley vibe</span>
            
          </h1>

          {}
          <p className="mx-auto max-w-2xl font-sans text-lg tracking-[0.3em] text-white/70 md:text-xl uppercase">Luxury epoxy &amp; decorative coatings</p>

          {}
          <div className="pt-6">
            <Button asChild variant="ghost" size="lg" className="group h-14 border-none bg-white px-8 text-lg font-black uppercase tracking-widest text-black transition-all duration-300 hover:bg-white/90 rounded-none">
              
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 z-10 h-32 w-full bg-gradient-to-t from-black to-transparent" />
    </section>;
}